'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import ContactAPI from '../api/ContactAPI';
var contactAPI = new ContactAPI();

var ContactTracker = /*#__PURE__*/function () {
  function ContactTracker() {
    _classCallCheck(this, ContactTracker);
  }

  _createClass(ContactTracker, [{
    key: "saveContact",
    value: function saveContact(contactEmail, websiteGrade) {
      // Store on the HubSpot portal
      contactAPI.save(contactEmail, websiteGrade);
    }
  }]);

  return ContactTracker;
}();

export default new ContactTracker();